<template>
  <div class="detail_page">
    <!-- <div class="top-container flex_between">
      <div class="flex_center" style="cursor: pointer" @click="handleBack">
        <i class="el-icon-arrow-left" />
        <div class="split"></div>
        {{ $t("claimantActivity.activityClaimDetail") }}
      </div>
      <div>
        <el-button
          class="primary-btn"
          size="small"
          type="primary"
          @click="handleBack"
          >{{ $t("operate.backList") }}</el-button
        >
      </div>
    </div> -->

    <div class="contentInfo">
      <div>
        <div class="hearder-title">
          <div class="flex_between">
            <img src="@/assets/image/basicRed.png" alt="dark" />
            {{ $t("claimantActivity.basicInfo") }}
          </div>
        </div>
        <div class="form-container">
          <el-descriptions class="desc-container" :column="3" border>
            <el-descriptions-item :label="$t('climant.climantNumber')">{{
              detailData.claimStatementNum
            }}</el-descriptions-item>
            <el-descriptions-item :label="$t('climant.climantStatus')">{{
              getStatusText(detailData.status)
            }}</el-descriptions-item>
            <el-descriptions-item :label="$t('claimantActivity.currency')">{{
              getCurrencyText(detailData.currency)
            }}</el-descriptions-item>
            <el-descriptions-item
              :label="$t('claimantActivity.activityAmount')"
              >{{ detailData.amount }}</el-descriptions-item
            >
            <el-descriptions-item :label="$t('claimantActivity.createTime')">{{
              detailData.createTime ? detailData.createTime.replace('T', ' ') : ''
            }}</el-descriptions-item>
            <el-descriptions-item
              :label="$t('claimantActivity.activityDesc')"
              >{{ detailData.activityDescription }}</el-descriptions-item
            >
          </el-descriptions>
        </div>
      </div>

      <div>
        <div class="hearder-title">
          <div class="flex_between">
            <img src="@/assets/image/carInfo.png" alt="" />
            {{ $t("claimantActivity.vehicleInfo") }}
          </div>
        </div>
        <div class="table-container">
          <el-table
            ref="tableRef"
            stripe
            border
            :data="detailData.vehicleList"
            max-height="450px"
          >
            <el-table-column
              type="index"
              :label="$t('cart.xh')"
              width="60"
              :render-header="$globalRenderHeader"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="vin"
              :label="$t('seek.vin')"
              min-width="180"
              :render-header="$globalRenderHeader"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="carBrand"
              :label="$t('home.brand')"
              min-width="100"
              :render-header="$globalRenderHeader"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="carModel"
              :label="$t('home.carType')"
              min-width="120"
              :render-header="$globalRenderHeader"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="carAttribute"
              :label="$t('climant.carAttribute')"
              min-width="100"
              :render-header="$globalRenderHeader"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.carAttribute === 0">{{
                  $t("climant.ryc")
                }}</span>
                <span v-else-if="scope.row.carAttribute === 1">{{
                  $t("climant.ddc")
                }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
              property="productionDate"
              :label="$t('seek.produceDate')"
              width="140"
              :render-header="$globalRenderHeader"
              align="center"
            >
            </el-table-column>

            <el-table-column
              :label="$t('home.attachmentInfo')"
              min-width="300"
              :render-header="$globalRenderHeader"
              align="center"
            >
              <template slot-scope="scope">
                <div class="file-thumbnails">
                  <div
                    v-for="(file, index) in (scope.row.fileList || []).slice(
                      0,
                      3
                    )"
                    :key="index"
                    class="thumbnail-item"
                    @click="handlePreviewFile(scope.row.fileList, index)"
                  >
                    <img :src="getFileIcon(file)" alt="" />
                    <span class="file-name" :title="file.name || file.fileName">
                      {{
                        (file.name || file.fileName || "").substring(0, 8)
                      }}...
                    </span>
                  </div>
                  <div
                    v-if="(scope.row.fileList || []).length > 3"
                    class="more-files"
                  >
                    +{{ scope.row.fileList.length - 3 }}
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="total-row">
            <span>{{ $t("claimantActivity.vinCount") }}: {{ vinCount }}</span>
            <span style="margin-left: 30px"
              >{{ $t("claimantActivity.totalAmount") }}: {{ totalAmount }}</span
            >
          </div>
        </div>
      </div>
    </div>

    <div class="content-info">
      <!--
      <el-form :inline="true" :model="detailData" label-width="150px">
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            {{ $t("claimantActivity.basicInfo") }}
          </div>
        </div>
        <div class="form-container">
          <el-form-item :label="$t('climant.climantNumber')">
            <el-input disabled v-model="detailData.claimStatementNum"></el-input>
          </el-form-item>
          <el-form-item :label="$t('climant.climantStatus')">
            <span>{{ getStatusText(detailData.status) }}</span>
          </el-form-item>
          <el-form-item :label="$t('claimantActivity.currency')">
            <el-input disabled v-model="detailData.currency"></el-input>
          </el-form-item>
          <el-form-item :label="$t('claimantActivity.activityAmount')">
            <el-input disabled v-model="detailData.amount"></el-input>
          </el-form-item>
          <el-form-item :label="$t('claimantActivity.createTime')">
            <el-input disabled v-model="detailData.createTime"></el-input>
          </el-form-item>
          <el-form-item :label="$t('claimantActivity.activityDesc')" class="full-width">
            <el-input
              v-model="detailData.activityDescription"
              type="textarea"
              :rows="3"
              disabled
              class="activity-desc-input"
            ></el-input>
          </el-form-item>
        </div>

        <div class="hearder-title" style="margin-top: 20px">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            {{ $t("claimantActivity.vehicleInfo") }}
          </div>
        </div>
        <div class="form-container">
          <el-table
            ref="tableRef"
            stripe
            border
            :data="detailData.vehicleList"
            max-height="450px"
          >
            <el-table-column
              type="index"
              :label="$t('cart.xh')"
              width="60"
              :render-header="$globalRenderHeader"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="vin"
              :label="$t('seek.vin')"
              min-width="180"
              :render-header="$globalRenderHeader"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="carBrand"
              :label="$t('home.brand')"
              min-width="100"
              :render-header="$globalRenderHeader"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="carModel"
              :label="$t('home.carType')"
              min-width="120"
              :render-header="$globalRenderHeader"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="carAttribute"
              :label="$t('climant.carAttribute')"
              min-width="100"
              :render-header="$globalRenderHeader"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.carAttribute === 0">{{ $t("climant.ryc") }}</span>
                <span v-else-if="scope.row.carAttribute === 1">{{ $t("climant.ddc") }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
              property="productionDate"
              :label="$t('seek.produceDate')"
              min-width="140"
              :render-header="$globalRenderHeader"
              align="center"
            >
            </el-table-column>
            <el-table-column
              :label="$t('home.attachmentInfo')"
              min-width="200"
              :render-header="$globalRenderHeader"
              align="center"
            >
              <template slot-scope="scope">
                <div class="file-thumbnails">
                  <div
                    v-for="(file, index) in (scope.row.fileList || []).slice(0, 3)"
                    :key="index"
                    class="thumbnail-item"
                    @click="handlePreviewFile(scope.row.fileList, index)"
                  >
                    <img :src="getFileIcon(file)" alt="" />
                    <span class="file-name" :title="file.name || file.fileName">
                      {{ (file.name || file.fileName || '').substring(0, 8) }}...
                    </span>
                  </div>
                  <div v-if="(scope.row.fileList || []).length > 3" class="more-files">
                    +{{ scope.row.fileList.length - 3 }}
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="total-row">
            <span>{{ $t("claimantActivity.vinCount") }}: {{ vinCount }}</span>
            <span style="margin-left: 30px"
              >{{ $t("claimantActivity.totalAmount") }}: {{ totalAmount }}</span
            >
          </div>
        </div>
      </el-form> -->
    </div>
    <view-img-video ref="viewImgVideoRef" :list="previewFileList" />
  </div>
</template>

<script>
import { getActivityClaimDetail } from "@/api/activityClaimant";
import viewImgVideo from "@/components/viewImgVideo.vue";

export default {
  components: {
    viewImgVideo,
  },
  data() {
    return {
      detailData: {},
      previewFileList: [],
    };
  },
  computed: {
    vinCount() {
      return (this.detailData.vehicleList || []).length;
    },
    totalAmount() {
      return ((this.detailData.amount || 0) * this.vinCount).toFixed(2);
    },
  },
  mounted() {
    const activityClaimId = this.$route.query.activityClaimId;
    if (activityClaimId) {
      this.getDetail(activityClaimId);
    }
  },
  methods: {
    async getDetail(activityClaimId) {
      const res = await getActivityClaimDetail({
        data: { activityClaimId: activityClaimId },
      });
      if (res.status == 0) {
        this.detailData = res.data || {};
      }
    },
    getStatusText(status) {
      const statusMap = {
        0: this.$t("climant.noSubmit"),
        1: this.$t("cart.audit"),
        2: this.$t("climant.rejected"),
        3: this.$t("claimantActivity.pendingSettlement"),
        4: this.$t("claimantActivity.settled"),
      };
      return statusMap[status] || "";
    },
    getCurrencyText(currency) {
      const currencyMap = {
        0: "CNY",
        1: "USD",
        2: "EUR",
        3: "GBP"
      };
      return currencyMap[currency] || currency || "";
    },
    getFileIcon(file) {
      const fileName = file.name || file.fileName || "";
      const ext = fileName.split(".").pop().toLowerCase();
      const imgExts = ["jpg", "jpeg", "png", "gif", "svg", "bmp"];
      const videoExts = [
        "mp4",
        "avi",
        "mov",
        "wmv",
        "flv",
        "mkv",
        "3gp",
        "m4v",
      ];
      const docExts = ["doc", "docx", "pdf", "txt"];
      const xlsExts = ["xls", "xlsx"];
      const zipExts = ["zip", "rar", "7z"];

      if (imgExts.includes(ext)) {
        return file.url || file.filePath || "";
      } else if (videoExts.includes(ext)) {
        return require("@/assets/image/mp4.png");
      } else if (xlsExts.includes(ext)) {
        return require("@/assets/image/xls.png");
      } else if (docExts.includes(ext)) {
        return require("@/assets/image/doc.png");
      } else if (zipExts.includes(ext)) {
        return require("@/assets/image/zip.png");
      }
      return require("@/assets/image/fileIcon.png");
    },
    handlePreviewFile(fileList, index) {
      const imgExts = ["jpg", "jpeg", "png", "gif", "svg", "bmp"];
      const previewList = fileList.filter((file) => {
        const fileName = file.name || file.fileName || "";
        const ext = fileName.split(".").pop().toLowerCase();
        return imgExts.includes(ext);
      });
      if (previewList.length > 0) {
        this.previewFileList = previewList;
        const fileItem = fileList[index];
        this.$nextTick(() => {
          this.$refs.viewImgVideoRef.init(fileItem, previewList);
        });
      }
    },
    handleBack() {
      this.$router.push("/activityClaimant");
    },
  },
};
</script>

<style lang="scss" scoped>

.detail_page .contentInfo>div>.hearder-title:first-child {
  border-top: 1px solid var(--line-color)!important;
}
.detail_page .contentInfo>div:first-child>.hearder-title:first-child {
  border-top: none !important;
}
// .detail_page {
//   padding: 20px;
// }
// .top-container {
//   margin-bottom: 20px;
// }
// .content-info {
//   background: #fff;
//   padding: 20px;
//   border-radius: 4px;
// }
// .hearder-title {
//   margin-bottom: 15px;
// }
// .form-container {
//   margin-bottom: 20px;
// }
.total-row {
  margin-top: 15px;
  padding: 10px;
  background: #f5f7fa;
  font-weight: bold;
}
.file-thumbnails {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  gap: 5px;
}
.thumbnail-item {
  position: relative;
  width: 50px;
  height: 50px;
  border: 1px solid #ddd;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
}
.thumbnail-item img {
  width: 30px;
  height: 30px;
  object-fit: contain;
}
.thumbnail-item .file-name {
  font-size: 10px;
  color: #666;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.more-files {
  width: 50px;
  height: 50px;
  border: 1px dashed #ddd;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 12px;
}
// ::v-deep .full-width {
//   display: block;
// }
// ::v-deep .full-width .el-form-item__content {
//   width: 60%;
// }
// ::v-deep .full-width {
//   display: block;
//   margin-right: 80px;
// }
// ::v-deep .full-width .el-form-item__content {
//   width: 20%;
// }
</style>
